import { Link } from "react-router-dom";
import { NAV_GROUPS, ROUTES } from "@/content/routes";
import { ENGAGE_PATHS, PATH_IDS, engageHref } from "@/content/engage";
import { Container, DraftTag, Mono, Wordmark } from "@/components/site/primitives";

const FooterLink = ({ to, state, testid, children }) => (
  <li>
    <Link to={to} state={state} data-testid={testid} className="text-sm text-o-dim transition-colors hover:text-o-text">
      {children}
    </Link>
  </li>
);

export const SiteFooter = () => (
  <footer className="t-ink border-t border-o-line bg-o-bg text-o-text" data-testid="site-footer">
    <Container className="py-16">
      <div className="grid gap-12 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <Wordmark testid="footer-wordmark" />
          <p className="mt-4 max-w-sm text-sm leading-relaxed text-o-dim">
            A research, diagnostics, software, and product-development company built around understanding and improving human structure.
          </p>
          <DraftTag className="mt-4" />
        </div>
        <nav aria-label="Site map" className="grid gap-10 sm:grid-cols-2 md:grid-cols-4 lg:col-span-8">
          {NAV_GROUPS.map((g) => (
            <div key={g.key}>
              <Mono accent>{g.label}</Mono>
              <ul className="mt-4 space-y-2">
                {g.items.map((it) => (
                  <FooterLink key={it.key} to={ROUTES[it.key].path} state={it.via ? { via: it.via } : undefined} testid={`footer-${g.key}-${it.key}`}>
                    {it.label}
                  </FooterLink>
                ))}
              </ul>
            </div>
          ))}
          <div>
            <Mono accent>Engage</Mono>
            <ul className="mt-4 space-y-2">
              {PATH_IDS.map((id) => (
                <FooterLink key={id} to={engageHref(id)} testid={`footer-engage-${id}`}>
                  {ENGAGE_PATHS[id].short}
                </FooterLink>
              ))}
            </ul>
          </div>
        </nav>
      </div>
      <div className="mt-14 flex flex-col gap-3 border-t border-o-line pt-6 font-mono text-[10.5px] uppercase tracking-[0.16em] text-o-dim sm:flex-row sm:justify-between">
        <span>© 2026 Ordo Intelligence</span>
        <span>Phase 1 structural prototype · Provisional content · No contact details published</span>
      </div>
    </Container>
  </footer>
);
